// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b1890706","697":"7dc45f6c"}[chunkId] + ".chunk.js";
};